import {PageTitle} from 'layout/master-layout'
import {useTranslation} from 'react-i18next'
import CropMasterListing from './CropMasterListing'

const CropMaster = () => {
 const {t} = useTranslation()

 return (
  <div className='container relative'>
   <div className='px-[72px] pt-6 pb-10 bg-white w-full min-h-full'>
    <PageTitle
     breadcrumbContainerClass='flex text-[#5A6066] text-sm font-normal items-center pb-6 border-[#E6EBF0]'
     breadcrumbs={[
      {
       title: t('breadCrumbs.home'),
       path: '/home-page',
       isActive: false,
      },
      {
       title: t('breadCrumbs.cropMaster'),
       path: '',
       isActive: true,
      },
     ]}
     description='Welcome'
    >
     {t('breadCrumbs.cropMaster')}
    </PageTitle>

    <CropMasterListing />
   </div>
  </div>
 )
}

export default function CropMasterWrapper() {
 return <CropMaster />
}
